import script from "./DisplayProperty.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisplayProperty.vue?vue&type=script&lang=ts&setup=true"

import "./DisplayProperty.vue?vue&type=style&index=0&id=469b8591&lang=scss"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QSkeleton});
